/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-param-reassign, import/extensions, import/no-unresolved */

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  makeRemoteCustomerGoalData,
  makeRemoteCustomerGoalDataItem,
  makeRemoteCustomerGoalDataTotal,
  makeRemoteCustomerGoalDataStatus,
  makeRemoteCustomerGoalDataProdutoEstrategico,
  makeRemoteCustomerGoalDataProdutoEstrategicoItem,
} from '../../usecases/customer-goals/customer-goals'

export interface CustomerGoalsStatus {
  readOnly: boolean,
  status: string,
  showButtonAprovacao?: boolean,
  showButtonReprovacao?: boolean,
  showButtonRevisao?: boolean,
  showButtonEnviarAprovacao?: boolean,
  dataReferencia?: string,
  metaClienteId?: number,
  aprovacoes: {
    dataHoraConfirmacao: string,
    ordem: number,
    papel: string,
    statusAprovacao: string,
    usuario: string
  }[],
  comentarios: {
    dataHora: string,
    reprovacao: boolean,
    texto: string,
    usuario: string
  }[],
}

interface DataInterface {
  list: any,
  loading: boolean,
  loaded: boolean,
  size?: number,
  page?: number,
  totalPages?: number,
  totalElements?: number,
}

export interface CustomerGoalDataStateInterface {
  data: DataInterface,
  produtosEstrategicos: DataInterface
  codigoGrupo ?: number,
  configuracaoPeriodoId?: number,
  divisao?: string,
  status: CustomerGoalsStatus
}

// Define the initial state using that type
const initialState: CustomerGoalDataStateInterface = {
  data: {
    list: [],
    loading: true,
    loaded: false,
  },
  produtosEstrategicos: {
    list: [],
    loading: true,
    loaded: false,
  },
  status: {
    readOnly: true,
    status: 'NAO_REGISTRADA',
    aprovacoes: [],
    comentarios: [],
  },
}

export interface CustomerGoalDataParamsProps {
  numeroItem?: number,
  codigoGrupo?: number,
  configuracaoPeriodoId?: number,
  divisao?: string,
  ano?: number
  division?: string,
  filterString?: string,
  filterType?: string,
  status?: string,
  size?: number,
  page?: number,
  sort?: string
}

export const fetchCustomerGoalData = createAsyncThunk(
  'customer-goals-data/index',
  async (params: CustomerGoalDataParamsProps) => {
    const response = await makeRemoteCustomerGoalData().index(params)

    return response
  },
)

export const fetchCustomerGoalDataProdutosEstrategicos = createAsyncThunk(
  'customer-goals-data/produtos-estrategicos',
  async (params: CustomerGoalDataParamsProps) => {
    const response = await makeRemoteCustomerGoalDataProdutoEstrategico().index(params)
    return response
  },
)

export const fetchCustomerGoalDataStatus = createAsyncThunk(
  'customer-goals-data/status',
  async (params?: CustomerGoalDataParamsProps) => {
    const response = await makeRemoteCustomerGoalDataStatus().index(params)

    return response
  },
)

export const fetchCustomerGoalDataTotal = createAsyncThunk(
  'customer-goals/total',
  async (params: CustomerGoalDataParamsProps) => {
    const response = await makeRemoteCustomerGoalDataTotal().index(params)
    return response
  },
)

export const fetchCustomerGoalDataItem = createAsyncThunk(
  'customer-goals/item',
  async (params: CustomerGoalDataParamsProps) => {
    if (params?.numeroItem) {
      const response = await makeRemoteCustomerGoalDataItem().index(params)
      return response
    }
    return null
  },
)

export const fetchCustomerGoalDataProdutosEstrategicosItem = createAsyncThunk(
  'customer-goals-produtos-estrategicos/item',
  async (params: CustomerGoalDataParamsProps) => {
    if (params?.numeroItem) {
      const response = await makeRemoteCustomerGoalDataProdutoEstrategicoItem().index(params)
      return response
    }
    return null
  },
)

const slice = createSlice({
  name: 'customer-goals-data',
  initialState,
  reducers: {
    customerGoalsFilter(state, action) {
      if (action.payload.codigoGrupo) {
        state.codigoGrupo = action.payload.codigoGrupo
      }
      if (action.payload.configuracaoPeriodoId) {
        state.configuracaoPeriodoId = action.payload.configuracaoPeriodoId
      }
      if (action.payload.divisao) {
        state.divisao = action.payload.divisao
      }
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchCustomerGoalData.rejected, (state) => {
      state.data.loaded = false
      state.data.loading = false
    })
    builder.addCase(fetchCustomerGoalData.pending, (state) => {
      state.data.loaded = false
      state.data.loading = true
    })
    builder.addCase(fetchCustomerGoalData.fulfilled, (state, action) => {
      state.data.list = action.payload.content
      state.data.size = action.payload.size
      state.data.page = action.payload.number
      state.data.totalPages = action.payload.totalPages
      state.data.totalElements = action.payload.totalElements
      state.data.loaded = true
      state.data.loading = false
    })
    builder.addCase(fetchCustomerGoalDataProdutosEstrategicos.rejected, (state) => {
      state.produtosEstrategicos.loaded = false
      state.produtosEstrategicos.loading = false
    })
    builder.addCase(fetchCustomerGoalDataProdutosEstrategicos.pending, (state) => {
      state.produtosEstrategicos.loaded = false
      state.produtosEstrategicos.loading = true
    })
    builder.addCase(fetchCustomerGoalDataProdutosEstrategicos.fulfilled, (state, action) => {
      state.produtosEstrategicos.list = action.payload.content
      state.produtosEstrategicos.size = action.payload.size
      state.produtosEstrategicos.page = action.payload.number
      state.produtosEstrategicos.totalPages = action.payload.totalPages
      state.produtosEstrategicos.totalElements = action.payload.totalElements
      state.produtosEstrategicos.loaded = true
      state.produtosEstrategicos.loading = false
    })
    builder.addCase(fetchCustomerGoalDataStatus.fulfilled, (state, action) => {
      state.status = action.payload
    })
  },
})

export const {
  customerGoalsFilter,
} = slice.actions

export default slice.reducer
